import {ReactElement, useState} from "react";
import {Button, ToggleButton} from "@zendeskgarden/react-buttons";
import {Dropdown, Menu, Trigger} from "@zendeskgarden/react-dropdowns";
import {Settings, ToggleOffOutlined, ToggleOn} from "@material-ui/icons";
import {ReactComponent as ChevronIcon} from "@zendeskgarden/svg-icons/src/16/chevron-down-stroke.svg";
import css from "../../styles/css.module.scss";

export interface SettingsToggle {
    label: string;
    value: boolean;
    onToggle: () => void;
}

interface SettingsMenuProps {
    toggles: SettingsToggle[];
}

export function SettingsMenu({toggles}: SettingsMenuProps): ReactElement {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    return (
        <Dropdown isOpen={isOpen} onStateChange={options => setIsOpen(options.isOpen ?? false)}>
            <Trigger>
                <Button isBasic>
                    <Button.StartIcon>
                        <Settings />
                    </Button.StartIcon>
                    <label>Settings</label>
                    <Button.EndIcon isRotated={isOpen}>
                        <ChevronIcon />
                    </Button.EndIcon>
                </Button>
            </Trigger>
            <Menu className={css.settingsMenu} placement="bottom-end">
                <div className={css.settingsOptions}>
                    {toggles.map(toggle => (
                        <ToggleButton key={toggle.label} isBasic onClick={toggle.onToggle}>
                            {toggle.value ? <ToggleOn fontSize="large" /> : <ToggleOffOutlined fontSize="large" />}
                            <span style={{marginLeft: ".5rem"}}>{toggle.label}</span>
                        </ToggleButton>
                    ))}
                </div>
            </Menu>
        </Dropdown>
    );
}
